import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import TextField from '@mui/material/TextField';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { Views } from './../../enums/enums';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import searchStore from '../../stores/search';
import bgSearchStore from '../../stores/bgSearch';
import SearchListType from './SearchListType';
import sessionStore from '../../stores/session';
import messageStore from '../../stores/message';
import navigationStore from '../../stores/navigation';
import { isConstructorDeclaration } from 'typescript';
import { generateId } from '../../services/random';
import songbookSessionStore from './../../stores/songbookSession';

function SearchField(props) {

  const itemsOnPage = 25;

  const sessionToken = props.isSongbook ? songbookSessionStore((state) => state.sessionToken) : sessionStore((state) => state.sessionToken);
  const searchQuery = searchStore((state) => state.searchQuery);
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const searchSuggest = searchStore((state) => state.searchSuggest);
  const itemsSuggested = searchStore((state) => state.itemsSuggested);
  const search = searchStore((state) => state.search);
  const goToView = navigationStore((state) => state.goToView);
  const setError = messageStore((state) => state.setError);
  const clearFilters = searchStore((state) => state.clearFilters);
  const musicSearchQuery = bgSearchStore((state) => state.searchQuery);
  const setMusicSearchQuery = bgSearchStore((state) => state.setSearchQuery);
  const musicSearchSuggest = bgSearchStore((state) => state.searchSuggest);
  const musicItemsSuggested = bgSearchStore((state) => state.itemsSuggested);
  const musicSearch = bgSearchStore((state) => state.search);
  const isWaitingSuggested = searchStore((state) => state.isWaitingSuggested);
  const isMusicWaitingSuggested = bgSearchStore((state) => state.isWaitingSuggested);

  const [showClearButton, setShowClearButton] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchTimeouts, setSearchTimeouts] = useState({});
  const searchRef = useRef(null);
  const [suggestIndex, setSuggestIndex] = useState(-1);
  const [focusTimeout, setFocusTimeout] = useState(null);
  const [blurTimeout, setBlurTimeout] = useState(null);

  useEffect(() => {

    if (props.value.length > 0) {
      setShowClearButton(true);
    } else {
      setShowClearButton(false);
    }
  }, []);

  useEffect(() => {

    if (!props.isNavBar) {
      if (searchQuery.length > 0) {
        setShowClearButton(true);
      } else {
        setShowClearButton(false);
      }
    }
  }, [searchQuery]);

  useEffect(() => {

    if (props.onref) {
      if (props.onref.current) {
        if (props.onref.current.value.length > 0) {
          setShowClearButton(true);
        } else {
          setShowClearButton(false);
        }
      }
    }
  }, [props.onref]);

  const handleClear = () => {
    setShowClearButton(false);
    props.onSearchQueryChange({
      target: {
        value: ""
      }
    });
    if (props.onref) {
      if (props.onref.current) {
        props.onref.current.value = "";
        props.onref.current.focus();
      }
    }
  };

  const renderClearButton = () => {

    if (showClearButton) {
      return <IconButton onClick={handleClear}>
        <ClearIcon />
      </IconButton>;
    }
  };

  useEffect(() => {
    let newSearchTimeouts = { ...searchTimeouts };
    if (itemsSuggested) {
      if (newSearchTimeouts[itemsSuggested.id]) {
        if (itemsSuggested.length > 0) {
          setSuggestIndex(-1);
          setMenuOpen(true);
        }
        delete newSearchTimeouts[itemsSuggested.id];
        setSearchTimeouts(newSearchTimeouts);
        setFocusToField();
      }
    }
  }, [itemsSuggested]);

  const setFocusToField = () => {
    let searchFieldDom = document.getElementById(props.id);
    if (searchFieldDom) {
      setTimeout(() => searchFieldDom.focus(), 100);
    }
  };

  const blurField = () => {
    let searchFieldDom = document.getElementById(props.id);
    if (searchFieldDom) {
      setTimeout(() => searchFieldDom.blur(), 150);
    }
  };

  useEffect(() => {
    let newSearchTimeouts = { ...searchTimeouts };
    if (musicItemsSuggested) {
      if (newSearchTimeouts[musicItemsSuggested.id]) {
        if (musicItemsSuggested.length > 0) {
          setSuggestIndex(-1);
          setMenuOpen(true);
        }
        delete newSearchTimeouts[musicItemsSuggested.id];
        setSearchTimeouts(newSearchTimeouts);
        setFocusToField();
      }
    }
  }, [musicItemsSuggested]);

  const clearTimeouts = () => {
    for (const [key, value] of Object.entries(searchTimeouts)) {
      clearTimeout(value);
      delete searchTimeouts[key];
    }
  };

  const handleSearchQueryChange = (e) => {
    if (e.target.value.length == 0) {
      setMenuOpen(false);
    }
    console.log("musicSearch change");
    setAnchorEl(e.currentTarget);
    clearTimeouts();
    let timeoutId = generateId();
    let timeout = setTimeout(() => {
      console.log("musicSearch S");
      if (e.target.value.length >= 2) {
        if (props.isBackgroundMusic) {
          musicSearchSuggest(sessionToken, e.target.value, timeoutId);
        } else {
          searchSuggest(sessionToken, e.target.value, props.isNavBar, timeoutId);
        }
        setFocusToField();
      }
    }, 700);
    let newSearchTimeouts = { ...searchTimeouts };
    newSearchTimeouts[timeoutId] = timeout;
    setSearchTimeouts(newSearchTimeouts);
    props.onSearchQueryChange(e);
    if (e.target.value.length > 0) {
      setShowClearButton(true);
    } else {
      setShowClearButton(false);
    }
  };

  const handleSuggestSearch = (query) => {
    if (query.length > 1) {
      if (props.onref) {
        if (props.onref.current) {
          props.onref.current.value = query;
        }
      }
      if (props.isBackgroundMusic) {
        setMusicSearchQuery(query);
        musicSearch(sessionToken, itemsOnPage);
      } else {
        if (props.isNavBar) {
          clearFilters();
        }
        setSearchQuery(query);
        search(sessionToken, itemsOnPage);
        goToView(Views.Search);
      }
      setMenuOpen(false);
      blurField();
    } else {
      setError(sessionToken, 0, TR.cm_seach_text_too_short);
    }
  };

  const handleKeyDown = (e) => {
    console.log("keydown", e.key, suggestIndex);
    if (e.key == "Escape") {
      setMenuOpen(false);
    }
    if (e.key === "ArrowDown" && menuOpen) {
      e.preventDefault();
      e.stopPropagation();
      if (props.isBackgroundMusic) {
        if (suggestIndex < musicItemsSuggested.length - 1) {
          setSuggestIndex(suggestIndex + 1);
        }
      } else {
        if (suggestIndex < itemsSuggested.length - 1) {
          setSuggestIndex(suggestIndex + 1);
        }
      }
    }
    if (e.key === "ArrowUp" && menuOpen) {
      e.preventDefault();
      e.stopPropagation();
      if (suggestIndex >= 0) {
        setSuggestIndex(suggestIndex - 1);
      }
    }
    if (e.key === "Enter" && suggestIndex == -1) {
      if (props.isNavBar) {
        clearFilters();
      }
      clearTimeouts();
      blurField();
      setMenuOpen(false);
    }
    if (e.key === "Enter" && suggestIndex >= 0 && menuOpen) {
      e.preventDefault();
      e.stopPropagation();
      if (props.isBackgroundMusic) {
        handleSuggestSearch(musicItemsSuggested[suggestIndex].value);
      } else {
        handleSuggestSearch(itemsSuggested[suggestIndex].value);
      }
      return;
    }
    props.onKeyDown(e);
  };

  const renderStartAdorment = () => {
    let searchFieldDom = document.getElementById(props.id);
    if (searchFieldDom) {
      if (document.activeElement === searchFieldDom && (isWaitingSuggested || isMusicWaitingSuggested)) {
        return <Box sx={{ display: 'flex', paddingRight: 2 }}>
          <CircularProgress size={"1.5rem"} />
        </Box>;
      }
    }
    return <InputAdornment position="start">
      <IconButton onClick={() => {
        if (props.isNavBar) {
          clearFilters();
        }
        clearTimeouts();
        props.onSearch();
      }}>
        <SearchIcon />
      </IconButton>
    </InputAdornment>;
  };

  return (
    <div>
      <TextField
        id={props.id}
        ref={searchRef}
        inputRef={props.onref}
        className={props.className}
        style={props.style}
        size="small"
        placeholder={props.placeholder ? props.placeholder : ""}
        defaultValue={props.value}
        onChange={handleSearchQueryChange}
        onKeyDown={handleKeyDown}
        InputProps={{
          startAdornment: (
            renderStartAdorment()
          ),
          endAdornment: (
            <InputAdornment position="end">
              {renderClearButton()}
            </InputAdornment>
          )
        }}
      />
      <SearchListType
        id={props.id+"-list"}
        fieldId={props.id}
        open={menuOpen}
        anchorEl={anchorEl}
        suggestIndex={suggestIndex}
        searchInputRef={props.onref}
        items={props.isBackgroundMusic ? musicItemsSuggested : itemsSuggested}
        onClose={() => setMenuOpen(false)}
        onSearch={handleSuggestSearch}
      />
    </div>
  );
}

export default SearchField;